module.exports = __webpack_public_path__ + "static/media/schody61 - schody drewniane zabiegowe do garazu.9a3414db.jpg";